






import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

@Component<BaseFormRow>({})
export default class BaseFormRow extends Vue {
    @Prop({ type: Boolean, required: false }) public readonly actionsRow?: boolean
}
